import { faMobile } from '@fortawesome/pro-regular-svg-icons';
import AuthenticatorContext from 'components/Authenticator/AuthenticatorContext';
import CustomDialog from 'components/CustomDialog/CustomDialog';
import { MfaStatus } from 'lib/graphql/graphql';
import { useContext, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import DisableTotpForm from '../../DisableTotpForm';
import TotpForm from '../../TotpForm';
import MfaMethod from '../MfaMethod';

export default function MfaMethodApp() {
  const { mfaStatus } = useContext(AuthenticatorContext);
  const [mfaModalOpen, setMfaModalOpen] = useState(false);
  const [disableMfaOpen, setDisableMfaOpen] = useState(false);
  return (
    <>
      <MfaMethod
        icon={faMobile}
        isEnabled={mfaStatus === MfaStatus.Enabled}
        name={<FormattedMessage id="mfa_method_auth_app" />}
        description={<FormattedMessage id="mfa_method_auth_app_description" />}
        onEdit={() => setMfaModalOpen(true)}
        onDisable={() => setDisableMfaOpen(true)}
      />
      <CustomDialog
        open={mfaModalOpen}
        onClose={() => setMfaModalOpen(false)}
      >
        <TotpForm
          onClose={() => setMfaModalOpen(false)}
        />
      </CustomDialog>
      <CustomDialog
        open={disableMfaOpen}
        onClose={() => setDisableMfaOpen(false)}
      >
        <DisableTotpForm
          onClose={() => setDisableMfaOpen(false)}
        />
      </CustomDialog>
    </>
  );
}
